import { MainLayout } from "~/components";
import { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { HeroPage } from "./HeroPage";
import { height } from "@mui/system";
import { benefitsbg } from "~/assets";
import { Typography, Box } from "@mui/material";
import { uniqueLogo } from "~/assets";
import { adjustableLogo } from "~/assets";
import { opportunityLogo } from "~/assets";
import { benefitsBGmobile } from "~/assets";
import {linelink} from '~/assets'


const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("lg")]: {
      backgroundImage: `url(${benefitsbg})`,
      backgroundSize: "auto",
      paddingTop: 220, 
      backgroundPosition:"top"
      
    },
    backgroundImage: `url(${benefitsBGmobile})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center top",
    height: "auto",
  },
  mobileLogos:{
    alignItems: "center",
    textAlign: "center",
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  desktopHeading:{
    display:'none !important',
    [theme.breakpoints.up("lg")]: {
      display: "block !important",
    },
  },
  mobileHeading:{
    display:'block',
    [theme.breakpoints.up("lg")]: {
      display: "none !important",
    }
  },
  desktopRows:{
    // display:'none',
    // [theme.breakpoints.up("lg")]:{
    //   display:'block'
    // }
  }
}));

export const KeyBenefitsPage = () => {
  const classes = useStyles();
  return (







    <Box className={classes.root} marginX={{ xs: 2, lg: 20 }}>
      <Box display='flex' paddingTop={0} flexDirection={{xs:'column', lg:'row'}}>

        <Box className={classes.desktopHeading} marginTop={0} flex={0.5} display='flex' flexDirection='column' >

          <Box  display='flex' flexDirection='row' justifyContent='flex-end'>
            <Box  sx={{width:'350px'}} paddingRight='180px' >
              <Typography variant="body1" 
                textAlign={{ lg: "end", md:"start", xs: "center" }}>
                Unique
              </Typography>

              <Typography marginTop={2} fontSize="15px"  textAlign={{ lg: 'end', md: 'center', xs:'center' }} variant="body2">

                Skillsbite is a unique blockchain-based educational Ecosystem creating first gamified 
                Learn2Earn model, that aims to disrupt the traditional educational system.
              </Typography>
            </Box>
          </Box>

          <Box  paddingTop={15} paddingBottom={15} display='flex' flexDirection='row' justifyContent='flex-end'>
            <Box
            
            sx={{width:'350px'}} paddingRight='180px'
            >
              <Typography textAlign={{ lg: "end", md:"start", xs: "center" }} variant="body1">
                Adjustable
              </Typography>
              <Typography marginTop={2} fontSize="15px" textAlign={{ lg: 'end', md: 'center', xs:'center' }} variant="body2">
                Skillsbite opens up opportunities for new areas that are not
                currently fully covered in traditional education. We introduce the
                possibility of learning topics of the future and thus increase the
                chances of acquiring the skills of the future.
              </Typography>
            </Box>
          </Box>

        </Box>

        <Box className={classes.desktopHeading} paddingTop={0} flex={0.5} display='flex' flexDirection='column'>

          <Box display='flex' flexDirection='row' justifyContent='flex-start'>
            <Box paddingLeft='180px' sx={{width:'350px'}} textAlign={{lg:"start", xs:"center"}}>
                <Typography variant="h5"
                style={{
                  backgroundColor:"#F69501",
                  backgroundImage: 'linear-gradient(268.99deg, #F69501 0.03%, #F1756E 100.53%)',
                  WebkitTextFillColor:'transparent',
                  backgroundClip:'text',
                  WebkitBackgroundClip:'text'
                }}
                fontSize={{xs:'12px', md:'16px'}}
                lineHeight={{xs:'18px', md:'26px'}}
                letterSpacing='0.2rem'

                >WHY ARE WE UNIQUE ?</Typography>
                <Typography variant="h6" marginTop={2} className={classes.desktopHeading}>Key benefits of Skillsbite</Typography>
                <Typography variant="h6" className={classes.mobileHeading} fontSize='24px'>Key benefits of Skillsbite</Typography>
            </Box>
          </Box>

          <Box  paddingTop={10} display='flex' flexDirection='row' justifyContent='flex-start'>
            <Box
            
            paddingLeft='180px' sx={{width:'350px'}}
            >
              <Box className={classes.mobileLogos}>
                <img src={opportunityLogo}></img>
              </Box>
              <Typography textAlign={{ lg: "start", md: "start", xs: "center" }} variant="body1">
                Opportunity
              </Typography>

              <Typography marginTop={2} fontSize="15px" textAlign={{ lg: 'start', md: 'center', xs:'center' }} variant="body2">
                

                There is an opportunity for learners to be aligned with
                educational content that’s delivered in their preferred learning
                style. This will allow every user to learn anything, in a manner
                suited to them while earning rewards through $SKILLS tokens.
              </Typography>
            </Box>
          </Box>
        </Box>



        <Box className={classes.mobileHeading} marginX={2} mt={10} display='flex' flexDirection='column'>
            <Typography variant="h5"
              style={{
                  backgroundColor:"#F69501",
                  backgroundImage: 'linear-gradient(268.99deg, #F69501 0.03%, #F1756E 100.53%)',
                  WebkitTextFillColor:'transparent',
                  backgroundClip:'text',
                  WebkitBackgroundClip:'text'
                }}
                fontSize={{xs:'12px', md:'16px'}}
                lineHeight={{xs:'18px', md:'26px'}}
                letterSpacing='0.2rem'
                textAlign='center'

                >WHY ARE WE UNIQUE ?
            </Typography>
            <Typography mt={1} textAlign='center' variant="h6" className={classes.mobileHeading}  fontSize={{xs:'24px', md:'40px'}}>
            Key benefits of Skillsbite
            </Typography>
        </Box>

        <Box mt={2} marginX={2} className={classes.mobileHeading} display='flex' flexDirection='column'>
          <Box alignItems='center' textAlign='center'>
            <img src={uniqueLogo}></img>
          </Box>
          <Typography textAlign='center' variant='h6' fontSize='20px'>
              Unique
          </Typography>
          <Typography mt={2} variant='body2' lineHeight='26px' textAlign='center'>
              Skillsbite is a unique blockchain-based educational Ecosystem creating first gamified 
              Learn2Earn model, that aims to disrupt the traditional educational system.
          </Typography>
          <Box mt={2} alignItems='center' textAlign='center'>
            <img src={linelink}></img>
          </Box>
        </Box>

        <Box marginX={2} className={classes.mobileHeading} display='flex' flexDirection='column'>
          <Box alignItems='center' textAlign='center'>
            <img src={adjustableLogo}></img>
          </Box>
          <Typography textAlign='center' variant='h6' fontSize='20px'>
              Adjustable
          </Typography>
          <Typography mt={2} variant='body2' lineHeight='26px' textAlign='center'>
              Skillsbite opens up opportunities for new areas that are not
              currently fully covered in traditional education. We introduce the
              possibility of learning topics of the future and thus increase the
              chances of acquiring the skills of the future.
          </Typography>
          <Box mt={2} alignItems='center' textAlign='center'>
            <img src={linelink}></img>
          </Box>
        </Box>

        <Box marginX={2} mb={10} className={classes.mobileHeading} display='flex' flexDirection='column'>
          <Box alignItems='center' textAlign='center'>
            <img src={opportunityLogo}></img>
          </Box>
          <Typography textAlign='center' variant='h6' fontSize='20px'>
              Opportunity
          </Typography>
          <Typography mt={2} variant='body2' lineHeight='26px' textAlign='center'>
            There is an opportunity for learners to be aligned with
            educational content that’s delivered in their preferred learning
            style. This will allow every user to learn anything, in a manner
            suited to them while earning rewards through $SKILLS tokens.
          </Typography>
        </Box>
      </Box>
    </Box>

  )
}
